import {Avatar} from "antd";
import React from "react";
import {BsFire} from "react-icons/bs";
import useTranslate from "../../../modules/local/useTranslate";
import classNames from "classnames";

export const HeaderBlock = ({
    icon = <BsFire size={21} className="text-color-100"/>,
    size = 31,
    title,
    renderTitle,
    wrapperClassName,
    className = 'background-200 text-base text-color-100',
    extra,
    ...props
}) => {

    const t = useTranslate()

    return (
        <div className={classNames("flex items-center", wrapperClassName)} {...props}>
            <Avatar
                size={size}
                icon={icon}
                className="flex flex-center background rounded-md"
            />
            <div
                style={{
                    padding: '0.5rem 0.75rem 0.5rem 1.75rem',
                    marginLeft: -16,
                    borderRadius: '0.25rem 0.5rem 0.5rem 0.25rem'
                }}
                className={classNames(
                    "flex items-center flex-1 font-bold leading-tight tracking-widest",
                    className,
                    title && 'uppercase'
                )}>
                <div className="flex-1">
                    {typeof renderTitle === 'function'
                        ? renderTitle()
                        : renderTitle || t(title)}
                </div>
                {extra}
            </div>
        </div>
    )
}